import type React from 'react'

// Shared by all 14 guides; was a module-local `s` in the single-file version.

// ── Styles ────────────────────────────────────────────────────────────────────
export const s: Record<string, React.CSSProperties> = {
  sidebar: {
    minWidth: 210,
    width: 210,
    flexShrink: 0,
    position: 'sticky',
    top: 0,
    // Cap to the visible scroll area (100vh - topbar - content padding) so the
    // nav itself scrolls on short windows instead of clipping.
    maxHeight: 'calc(100vh - 80px)',
    overflowY: 'auto',
  },
  content: {
    flex: 1,
    minWidth: 0,
    maxWidth: 720,
  },
  label: {
    fontFamily: 'var(--mono)',
    fontSize: '0.58rem',
    letterSpacing: '0.1em',
    color: 'var(--text3)',
    padding: '6px 0 6px',
    textTransform: 'uppercase',
  },
  navGroup: {
    marginBottom: 14,
  },
  navGroupLabel: {
    padding: '0 0 6px 8px',
  },
  navItem: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: '7px 10px',
    paddingLeft: 8,
    borderRadius: 5,
    border: 'none',
    borderLeft: '2px solid transparent',
    cursor: 'pointer',
    background: 'transparent',
    fontFamily: 'var(--mono)',
    fontSize: '0.7rem',
    color: 'var(--text2)',
    marginBottom: 2,
    transition: 'background 0.12s, color 0.12s',
  },
  navSubItem: {
    paddingLeft: 16,
  },
  navItemActive: {
    background: 'var(--accent-d)',
    color: 'var(--accent)',
    borderLeft: '2px solid var(--accent)',
  },
  guideTitle: {
    fontFamily: 'var(--head)',
    fontSize: '1.1rem',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    color: 'var(--text)',
    marginBottom: 10,
    marginTop: 0,
  },
  subTitle: {
    fontFamily: 'var(--head)',
    fontSize: '0.85rem',
    fontWeight: 600,
    color: 'var(--text)',
    marginTop: 24,
    marginBottom: 8,
  },
  para: {
    fontFamily: 'var(--body)',
    fontSize: '0.85rem',
    color: 'var(--text2)',
    lineHeight: 1.6,
    marginBottom: 12,
    marginTop: 0,
  },
  list: {
    fontFamily: 'var(--body)',
    fontSize: '0.85rem',
    color: 'var(--text2)',
    lineHeight: 1.8,
    paddingLeft: 20,
    marginTop: 0,
    marginBottom: 12,
  },
  link: {
    color: 'var(--accent)',
    textDecoration: 'none',
  },
  linkBtn: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    color: 'var(--accent)',
    fontFamily: 'var(--body)',
    fontSize: '0.85rem',
    textDecoration: 'underline',
  },
  code: {
    fontFamily: 'var(--mono)',
    fontSize: '0.8rem',
    background: 'var(--bg4)',
    border: '1px solid var(--border)',
    borderRadius: 3,
    padding: '0 4px',
    color: 'var(--text2)',
  },
}

